<load-user-language />
<dynamic-css-loader />

<div class="content-wrapper d-flex flex-column">
	<router-outlet name="header" />
	<div class="app-body d-flex flex-grow-1">
		<router-outlet name="navigation" />
		<main id="skiplink-content" class="main flex-grow-1 d-flex flex-column">
			<router-outlet name="top-title-bar" />
			<div class="flex-grow-1 position-relative">
				<router-outlet />
			</div>
		</main>
	</div>
</div>

<notification-negotiation />

<p-toast [baseZIndex]="99999" appendTo="body" [key]="toastKey" preventOpenDuplicates [position]="toastPosition">
	<ng-template #headless let-message let-closeFn="closeFn">
		<div class="p-toast-message-content">
			<div class="d-flex gap-3 flex-grow-1 align-items-start" [ngClass]="{ 'cursor-pointer clickable-toast': message.data?.action != null }" (click)="message.data?.action?.(); message.data?.action && closeFn($event)">
				<span
					class="p-toast-message-icon"
					[ngClass]="message.icon || {
					'pi': true,
					'pi-info-circle': message.severity === 'info',
					'pi-exclamation-triangle': message.severity === 'warn',
					'pi-times-circle': message.severity === 'error',
					'pi-check': message.severity === 'success'
				}">
				</span>
				<div class="p-toast-message-text">
					<div class="p-toast-summary">{{message.summary}}</div>
					<div class="p-toast-detail" [innerHTML]="message.detail | stripHtml:['strong', 'em']"></div>
					@if (message.data?.actions; as actions) {
						<div class="d-flex flex-wrap gap-2 mt-3">
							@for (action of actions; track $index) {
								<button
									type="button"
									pRipple
									class="toast-button"
									(click)="action.command?.(); closeFn($event)"
									[routerLink]="action.routerLink">
									<span>{{action.label}}</span>
								</button>
							}
						</div>
					}
				</div>
			</div>
			<button
				type="button"
				class="toast-close-button"
				(click)="closeFn($event)"
				aria-label="Close"
				i18n-aria-label="@@common.close">
				<span class="pi pi-times"></span>
			</button>
		</div>
	</ng-template>
</p-toast>

<context-menu />

<data-transfer-indicator />